export default function getGetOrdinalSuffix(n) {
	let s = ['th','st','nd','rd'],
			v = n % 100

	return n + (s[(v-20)%10]||s[v]||s[0])
}


// WEBPACK FOOTER //
// ./src/utilities/content/getOrdinalSuffix.js